import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagsFavorite = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "tags-favorite_icon",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M19.105 8.413A4 4 0 0 0 20.091 6V2a2 2 0 0 0-2-2l-4.258.005a3.95 3.95 0 0 0-2.415 1L.592 11.833a2 2 0 0 0 0 2.829L5.428 19.5a1.98 1.98 0 0 0 1.406.581h.011a1.98 1.98 0 0 0 1.411-.6l1.012-1.031a.5.5 0 0 0 .1-.539 5.02 5.02 0 0 1 6.448-6.578.49.49 0 0 0 .535-.108ZM12.591 5.5a2 2 0 1 1 2 2 2 2 0 0 1-2-2" }), /* @__PURE__ */ _jsx("path", { d: "M13.46 12.545a3.524 3.524 0 0 0-1.935 5.965l5.113 5.335a.5.5 0 0 0 .722 0l5.107-5.328a3.525 3.525 0 0 0-4.986-4.985l-.305.3a.25.25 0 0 1-.353 0l-.3-.3a3.5 3.5 0 0 0-3.063-.987" })]
});
export { SvgTagsFavorite as ReactComponent };
